export default "__VITE_ASSET__BUNF7f8S__"